import { CapacitorHttp, HttpResponse } from '@capacitor/core'

import { obtainTikTokRedirectUrl } from './obtainTikTokRedirectUrl'

// https://github.com/n0l3r/tiktok-downloader/blob/main/index.js
const tikTokReq = 'https://api16-normal-c-useast1a.tiktokv.com/aweme/v1/feed/'

interface IVideoMetadataResponse {
  caption: string
  videoNoWaterMarkUrl: string
}

// url: https://www.tiktok.com/@mothershipsg/video/7264913380278930695?_t=8f2T8v79ND8&amp;_r=1
const obtainTikTokVideoId = (url = '') => {
  const regexVideoId = /(@.*)\/video\/([0-9]*)/g

  const result = [...url.matchAll(regexVideoId)] || []

  return result?.[0]?.[2]
}

export const obtainTikTokVideoMetadata = async (
  url: string
): Promise<IVideoMetadataResponse> => {
  try {
    const redirectUrl = await obtainTikTokRedirectUrl(url)
    const videoId = obtainTikTokVideoId(redirectUrl)

    if (!videoId)
      return {
        caption: '',
        videoNoWaterMarkUrl: '',
      }

    const response: HttpResponse = await CapacitorHttp.get({
      url: tikTokReq,
      headers: { 'Content-Type': 'application/json' },
      // https://github.com/yt-dlp/yt-dlp/issues/9506
      params: {
        iid: '7318518857994389254',
        device_id: '7318517321748022790',
        version_code: '300904',
        aweme_id: videoId,
      },
    })

    const res = response?.data

    const videoNoWaterMarkUrl =
      res?.aweme_list?.[0]?.video?.play_addr?.url_list[0]

    const caption = res?.aweme_list?.[0]?.desc

    return {
      caption,
      videoNoWaterMarkUrl,
    }
  } catch (error) {
    console.error(error)
    return {
      caption: '',
      videoNoWaterMarkUrl: '',
    }
  }
}
